import {
  applicationInitialState,
  applicationReducer,
  changeHighlightViewedAction,
  changeListViewAction,
  changeMediaFilterAction,
  changeNightModeAction,
  changeNsfwAction,
  changeWideCommentsAction,
  changeSearchDefaultSort,
  changeFloppersDefaultSort,
  itemsInitialState,
  itemsReducer,
  settingsInitialState,
  settingsReducer,
  userInitialState,
  userReducer,
  changeDefaultSortAction,
  commentsReducer,
  commentsInitialState, 
  changeUpNextAction,
  adsShowBlockerConsentAction,
  changeCommentsUnderVideoAction,
  changeRelatedListTypeAction,
  userShowMobileItemInAppAction,
} from './ducks';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { stringGetCookie } from './cookie';
import { adsInitialState, adsReducer } from './ducks/ads';

export const DUMPERT_STATE = '__DUMPERT_STATE__';

/**
 * Helper map to set initial values from cookies
 * Cookie name mapped to default value and redux action to set another value
 * @type {{ [string]: { defaultValue:string, action:function } }
 */
export const persistentValues = Object.entries({
  nightMode: [settingsInitialState.nightMode, changeNightModeAction],
  filterMedia: [settingsInitialState.showMedia, changeMediaFilterAction],
  filterNsfw: [settingsInitialState.showNsfw, changeNsfwAction],
  upNext: [settingsInitialState.upNext, changeUpNextAction],
  relatedListType: [settingsInitialState.relatedListType, changeRelatedListTypeAction],
  commentsUnderVideo: [settingsInitialState.commentsUnderVideo, changeCommentsUnderVideoAction],
  wideComments: [settingsInitialState.wideComments, changeWideCommentsAction],
  highlightViewed: [settingsInitialState.highlightViewed, changeHighlightViewedAction],
  searchDefaultSort: [settingsInitialState.searchDefaultSort, changeSearchDefaultSort],
  floppersDefaultSort: [settingsInitialState.floppersDefaultSort, changeFloppersDefaultSort],
  filterView: [itemsInitialState.view, changeListViewAction],
  default_sort: [commentsInitialState.default_sort, changeDefaultSortAction],
  adsShowBlockerConsent: [adsInitialState.adsShowBlockerConsent, adsShowBlockerConsentAction],
  showMobileItemInApp: [userInitialState.showMobileItemInApp, userShowMobileItemInAppAction],
}).reduce((a, [k, [defaultValue, action]]) => ({ ...a, [k]: { defaultValue, action } }), {});


/**
 * Examine given value and convert it to defaultValue type
 * Check that value is string!
 * E.g. if default is boolean then it should be 'true' or 'false'
 * other values like undefined or null should be considered as not set.
 * Empty string is not valid value unless default value is also empty string.
 * @param value
 * @param defaultValue
 * @returns {boolean|*}
 */
export const getValueFromString = (value, defaultValue) => {
  if (defaultValue === false) {
    return value === 'true';
  }
  if (defaultValue === true) {
    return value !== 'false';
  }
  return value || defaultValue;
};

/**
 * settings per client that should be set into redux state from cookies
 * @param cookieStr
 * @param store
 */
export const updateSettingsStateFromCookie = (cookieStr, { dispatch }) => Object.entries(persistentValues)

// retrieve values from raw cookie string
  .map(([key, v]) => ({
    ...v, cookieValue: getValueFromString(stringGetCookie(key, cookieStr), v.defaultValue),
  }))

  // get values differ from defaults
  .filter(({ defaultValue, cookieValue }) => defaultValue !== cookieValue)

  // create redux actions
  .map(({ cookieValue, action }) => action(cookieValue))

  // update state
  .map(dispatch);


export const initialRootState = {
  ads: adsInitialState,
  items: itemsInitialState,
  settings: settingsInitialState,
  application: applicationInitialState,
  user: userInitialState,
  comments: commentsInitialState,
};

const composeEnhancers = (typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ?
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

export const createReduxStore = (state, monitor) => createStore(
  combineReducers({
    ads: adsReducer,
    items: itemsReducer,
    settings: settingsReducer,
    application: applicationReducer,
    user: userReducer,
    comments: commentsReducer,
  }),
  state || initialRootState,
  composeEnhancers(applyMiddleware(thunk.withExtraArgument({ monitor }))),
);


